import { useEffect, useState } from "react";
import client from "../api/client";
import { Loader2, CheckCircle2, XCircle, History } from "lucide-react";

const ROLE_LABEL = { admin: "Administrátor", user: "Koordinátor", lector: "Lektor" };

export default function AuditLog() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    client.get("/admin/audit-logs").then((res) => setItems(res.data)).catch(() => setItems([]));
  }, []);

  const fmt = (iso) => {
    if (!iso) return "—";
    try {
      return new Date(iso).toLocaleString("cs-CZ", {
        timeZone: "Europe/Prague", day: "2-digit", month: "2-digit", year: "numeric",
        hour: "2-digit", minute: "2-digit",
      });
    } catch {
      return iso.slice(0, 19).replace("T", " ");
    }
  };

  return (
    <>
      <div className="h-16 border-b border-border px-8 flex items-center gap-2 sticky top-0 bg-background/80 backdrop-blur-md z-10">
        <History className="h-5 w-5 text-muted-foreground" />
        <div>
          <h1 className="font-heading text-xl font-semibold tracking-tight">Evidence akcí</h1>
          <p className="text-xs text-muted-foreground">Záznam všech změn provedených uživateli (vytvoření, úpravy, mazání, notifikace, faktury).</p>
        </div>
      </div>

      <div className="p-8" data-testid="audit-log-page">
        {!items ? (
          <div className="text-sm text-muted-foreground flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Načítání…</div>
        ) : (
          <div className="border border-border rounded-lg overflow-hidden">
            <table className="w-full text-sm" data-testid="audit-log-table">
              <thead>
                <tr className="text-[11px] uppercase tracking-wide text-muted-foreground border-b border-border bg-muted/40">
                  <th className="text-left font-medium px-3 py-2">Kdy</th>
                  <th className="text-left font-medium px-3 py-2">Uživatel</th>
                  <th className="text-left font-medium px-3 py-2">Role</th>
                  <th className="text-left font-medium px-3 py-2">Akce</th>
                  <th className="text-left font-medium px-3 py-2">Stav</th>
                </tr>
              </thead>
              <tbody>
                {items.map((n, i) => (
                  <tr key={i} className="border-b border-border/60" data-testid={`audit-row-${i}`}>
                    <td className="px-3 py-2 text-muted-foreground whitespace-nowrap">{fmt(n.created_at)}</td>
                    <td className="px-3 py-2">
                      <div>{n.name || n.username || "—"}</div>
                      {n.name && n.username && <div className="text-[11px] text-muted-foreground">{n.username}</div>}
                    </td>
                    <td className="px-3 py-2 text-muted-foreground">{ROLE_LABEL[n.role] || n.role}</td>
                    <td className="px-3 py-2">{n.action}</td>
                    <td className="px-3 py-2">
                      {n.success ? (
                        <span className="inline-flex items-center gap-1 text-emerald-700 text-xs"><CheckCircle2 className="h-3.5 w-3.5" /> OK</span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-destructive text-xs"><XCircle className="h-3.5 w-3.5" /> Chyba ({n.status_code})</span>
                      )}
                    </td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-muted-foreground">Zatím žádné záznamy</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
